/**
 * @author      yewon@zumper.com (Yewon Lee)
 * @copyright   Copyright (c) 2018, Zumper
 * @description loadCity thunk
 */

import { cities } from '@zcode/nr/es/shared/api'
import { logger } from '../logger'
import { beginLoadingCity, errorLoadingCity, receiveCity } from './index'

const loadCity = (url, skipReceive) => (dispatch, getState) => {
  const params = { url: [url] }

  dispatch(beginLoadingCity(params))
  return cities
    .get(params)
    .then((city) => {
      if (!skipReceive) {
        dispatch(receiveCity({ city, params }))
      }
      return city
    })
    .catch((error) => {
      // We are handling the 404 by sending users through the determine missing location flow
      dispatch(errorLoadingCity({ error, params }))

      if (error.status !== 404) {
        logger.debug('loadCity failed:', url, error.data || error)
        return Promise.reject(error)
      }
    })
}

export default loadCity
